import React, {useCallback, useState} from 'react';
import styled from 'styled-components';
import Accordion from '../../BaseComponentWrappers/MotifAccordion';
import {useOverrideLabels} from '../../../Main/Forms/Utilities/OverrideLabelsProvider';
import RiskList from './Risks/RiskList';
import Utility from '../../../../util/utilityfunctions';

export default function RiskTypeListItem(props) {
	const {riskTypeId, risksList, getBodiesBySectionId, isDisplayAccounts, isDisabled} = props;
	const {currentResource, labels} = useOverrideLabels();

	const [isAccordionOpen, setIsAccordionOpen] = useState(true);

	const dummyCallback = useCallback(() => {}, []);

	return (
		<>
			<StyledRiskTypeListItem
				className={`StyledRiskTypeListItem ${Utility.getTheme() === 'dark' ? 'styledRiskTypeListItemDark' : ''}`}
			>
				<Accordion
					open={isAccordionOpen}
					onOpen={dummyCallback}
					onClose={dummyCallback}
					onClick={() => setIsAccordionOpen(!isAccordionOpen)}
					accordionHeading={currentResource.riskTypes[riskTypeId - 1].name}
					stopPropagation
					useChevronIcon
				>
					{props.risksList?.length > 0 ? (
						<RiskList
							risksList={risksList}
							isDisplayAccounts={isDisplayAccounts}
							getBodiesBySectionId={getBodiesBySectionId}
							isDisabled={isDisabled}
						/>
					) : (
						<section className="empty-template">
							<span className="no-identifiedrisks">
								{labels.noRisksIdentifiedForTheSpecificRiskType.replace(
									'{0}',
									currentResource.aresRiskTypes[riskTypeId - 1].name
								)}
							</span>
						</section>
					)}
				</Accordion>
			</StyledRiskTypeListItem>
		</>
	);
}

const StyledRiskTypeListItem = styled.section`
	margin-bottom: var(--px-24);
	cursor: default;
	.empty-template {
		height: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		cursor: default;
		border-top: var(--px-1) solid var(--neutrals-200);
		.no-identifiedrisks {
			color: var(--neutrals-700);
			font-size: var(--px-14);
			font-weight: 300;
			line-height: var(--px-20);
			padding: var(--px-24) 0;
		}
	}
`;
